// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--3Z5cR","wrapper":"_80ad21f8ef--wrapper--3m0aW","tabs":"_80ad21f8ef--tabs--1fG6x"};